import api from './index';

let exports = {};

//================ 服务请求单管理 =================
exports.getServcReqVoucherList = function (postData, callback) {// 获取服务请求单列表
    api.post('/servcDispt/servc/req/voucher/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getEsServcReqVoucherList = function (postData, callback) {// 从es中直接获取请求单信息
    api.post('/servcDispt/servc/req/voucher/list/get/es')
    .data(postData)
    .done(callback)
    .go();
};
//通过id获取服务请求单信息
exports.getServcReqVoucher = function (postData, callback) {// 获取服务请求单信息
    api.post('/servcDispt/servc/req/voucher/get')
    .data(postData)
    .done(callback)
    .go();
};
exports.getServcReqVoucherFileUrlList = function (params, callback) {// 获取服务请求单附件路径集合
    api.get('/servcDispt/servc/req/voucher/file/list/get')
    .params(params)
    .done(callback)
    .go();
};

//指派操作
exports.assignServcReqVoucher = function (postData, callback) {// 指派门店
    api.post('/servcDispt/servc/req/voucher/assign/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.rejectServcReqVoucher = function (postData, callback) {// 拒绝服务请求单
    api.post('/servcDispt/servc/req/voucher/reject/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.saveServcReqVoucher = function (postData, callback) {// 保存服务请求单
    api.post('/servcDispt/servc/req/voucher/save/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.proxySaveServcReqVoucher = function (postData, callback) {// 代理服务请求单
    api.post('/servcDispt/servc/req/voucher/save/proxy/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.setServcReqVoucherAccepted = function (paramsData, callback) {// 受理服务请求单
    api.post('/servcDispt/servc/req/voucher/accepted/set/do')
    .params(paramsData)
    .done(callback)
    .go();
};

exports.cancelServcReqVoucher = function (postData, callback) {// 服务请求单取消
    api.post('/servcDispt/req/voucher/cancel/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.proxySaveServcReqVoucherForRent = function (postData, callback) {
    api.post('/servcDispt/servc/req/voucher/save/proxy/for/rent/do')
    .data(postData)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/servcDispt.js
// module id = 95
// module chunks = 1